import { gql } from "graphql-request";

const SendVacationToRubrikaQuery = gql`
  mutation SendVacationToRubrika($input: InputSendVacationToRubrika!) {
    SendVacationToRubrika(input: $input) {
      status
      error
      messege
      data
    }
  }
`;

export default SendVacationToRubrikaQuery;
